import { FirebaseApp, initializeApp } from "firebase/app";
import {
  Analytics,
  getAnalytics,
  logEvent as firebaseLogEvent,
} from "firebase/analytics";

const getEnv = (key: string) => {
  console.log(window._env_, process.env);
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[`REACT_APP_${key}`] || "";
};

const firebaseConfig = {
  apiKey: getEnv("FIREBASE_API_KEY"),
  authDomain: getEnv("FIREBASE_AUTH_DOMAIN"),
  projectId: getEnv("FIREBASE_PROJECT_ID"),
  storageBucket: getEnv("FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: getEnv("FIREBASE_MESSAGING_SENDER_ID"),
  appId: getEnv("FIREBASE_APP_ID"),
  measurementId: getEnv("FIREBASE_MEASUREMENT_ID"),
};

let app: FirebaseApp | null = null;
let analytics: Analytics | null = null;

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  app = null;
  analytics = null;
} else {
  try {
    app = initializeApp(firebaseConfig);
    if (typeof window !== "undefined") {
      analytics = getAnalytics(app as FirebaseApp);
    }
  } catch (error) {
    console.error("Failed to initialize Firebase:", error);
    app = null;
    analytics = null;
  }
}

const logEvent = (
  analyticsInstance: Analytics | null,
  eventName: string,
  eventParams?: Record<string, unknown>,
): void => {
  if (!analyticsInstance) return;
  firebaseLogEvent(analyticsInstance, eventName, eventParams);
};

export { app, analytics, logEvent };
